import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.15_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/brochure-ui/src/components/ActieVoorwaardenLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/brochure-ui/src/components/CookiesPage.tsx");
